import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()(({ spacing, palette }) => ({
	priceRangeContainer: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	},
	priceRangeBlurContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: spacing.small,
	},
	priceInput: {
		'& > div > div': {
			marginRight: '7px',
		},
	},
	priceRangeValidationErrorText: {
		padding: `${spacing.small} ${spacing.xxsmall} 0`,

		'& span': {
			color: palette.blazeOrange['100'],
		},
	},
}));
